import React, { useState } from 'react'
import { Box, Flex, Group, Button, Input, TextInput, Text, ThemeIcon } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconClipboardText, IconTrash } from '@tabler/icons-react' 
import { validation } from '../../../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { useParams } from 'react-router-dom'
import { addOrderDocument } from '../../../../../services/orders'

const defaultVal = {
  name: '',
  document: []
}

const formValidation = {
  name: {
    isError: false,
    message: ''
  },
  document: {
    isError: false,
    message: ''
  }
}

const FormAddOrderDocument = ({ onCloseModal, reloadList }) => {
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const handleAddDocument = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      name: form.name,
      document: Object.keys(form.document).length > 0 ? 'document available' : ''
    }
    const isErrorForm = validation(validateForm, setValidationForm)
    if (isErrorForm) {
      notificationError('Upload Document Error', 'Please recheck your form')
      setLoadingForm(false)
      return
    }
    const payloadDocument = new FormData()
    payloadDocument.append('name', form.name)
    payloadDocument.append('document', form.document)
    try {
      const response = await addOrderDocument(orderId, payloadDocument)
      if (response.success) {
        notificationSuccess('Upload Document Success', 'Document uploaded successfully')
        onCloseModal()
        reloadList()
      } 
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Upload Document Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {
        document: {
          isError: true,
          message: errorMessage
        }
      }
      setValidationForm(error)
    }
  }

  const handleUploadDocument = (file) => {
    setValidationForm(formValidation)
    handleChangeForm('document', file[0])
  }

  const mappingUploadedDocument = (data) => {
    if (Object.keys(data).length > 0) {

      const handleRemoveUploadDocument = () => {
        handleChangeForm('document', [])
      }

      const mappingDocument = (data) => {
        return (
          <Flex justify='space-between' align='center'>
            <Text fz={13} c='gray.7'>{data.name}</Text>
            <Group gap={4}>
              <ThemeIcon variant="white" color="red" radius='lg' size='sm' style={{ cursor: 'pointer' }} onClick={() => handleRemoveUploadDocument()}><IconTrash style={{ width: '70%', height: '70%' }} /></ThemeIcon>
            </Group>
          </Flex>
        ) 
      }

      return (
        <Box>
          <Text fz={12} fw='500' mb='sm'>Uploaded Document</Text>
          <Box>{mappingDocument(data)}</Box>
        </Box>
      )
    }
  }

  return (
    <Box>
      <Box mb='md'>
        <TextInput
          name='name'
          value={formData.name}
          label='Name'
          error={validationForm.name.isError ? `${validationForm.name.message}` : ''}
          onChange={(val) => handleChangeForm('name', val.target.value)}
          withAsterisk
          size='xs'
        />
      </Box>
      <Box mb='md'>
        <Input.Wrapper 
          my={10} 
          label='Upload Document' 
          withAsterisk 
          error={validationForm.document.isError ? `${validationForm.document.message}` : ''} 
          size='xs'>
          <Box>
            <Dropzone 
              my={5}
              onDrop={(files) => handleUploadDocument(files)}
              onReject={(files) => handleErrorFile(files)}
              maxSize={5000000}
              disabled={Object.keys(formData.document).length > 0}
            >
              <Box ta='center' my={30}>
                <Flex justify='center' mb={10}>
                  <IconClipboardText size={50} color='gray' />
                </Flex>
                <Box>
                  <Text fz={12} c='blue.9'>Upload File Here</Text>
                  <Text fz={12} c='gray.6'>All format file up to 5 MB</Text>
                </Box>
              </Box>
            </Dropzone>
          </Box>
        </Input.Wrapper>
        <Box my={20}>   
          <Box>{mappingUploadedDocument(formData.document)}</Box>
        </Box>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => handleAddDocument(formData)}>Save</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAddOrderDocument